/* ========== Start Brides Gallery Page JS ========== */
$(document).ready(function(){
  var currentshopurl = $('.zoom-image-pagination .shop-base-url').val();
  var currenthandle = $('.zoom-image-pagination .current-url-handle').val();
  var articlescount = $('.zoom-image-pagination .wedding-article-count').val();
  var imageperpage = $('.zoom-image-pagination .images-per-page').val();
  var counter = 2;
  var pages = Math.ceil(articlescount / imageperpage);
  var maxCount = pages + 1;
  $('#grace-brides-gallery #blogLoadMore').click(function(e) {
      e.preventDefault();
      var getUrl = currentshopurl+"/blogs/"+currenthandle+"?page="+counter;
      $.ajax({
           url: getUrl,
           type:'GET',
           success: function(data){
              $('.zoom-gallery').append($(data).find('.zoom-gallery').html());
              counter++;
              if(counter == maxCount ) {
                  $('#grace-brides-gallery #blogLoadMore').empty();
              }

           }
      });
  });

  $('#grace-brides-gallery .zoom-gallery').magnificPopup({
    delegate: 'a',
    type: 'image',
    closeOnContentClick: false,
    closeBtnInside: false,
    closeOnBgClick: false,
    mainClass: 'mfp-with-zoom mfp-img-mobile',
    image: {
      verticalFit: true
    },
    gallery: {
      arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
      tPrev: 'Previous (Left arrow key)',
      tNext: 'Next (Right arrow key)',
      enabled: true,
      navigateByImgClick: false
    },
    zoom: {
      enabled: true,
      duration: 300,
      opener: function(element) {
        return element.find('img');
      }
    }
  });

  $('.shopify-section #blogLoadMore').click(function(e) {
    e.preventDefault();
    const pathname = window.location.pathname;
    var getUrl = currentshopurl + pathname + "?page=" + counter;
    console.log('yrk')

    $.ajax({
         url: getUrl,
         type:'GET',
         success: function(data){
            $('.zoom-gallery').append($(data).find('.zoom-gallery').html());
            
            const numPages = $('.pages-count').val();
            if( numPages == counter ) {
                $('.shopify-section #blogLoadMore').empty();
            }
            counter++;
            console.log('success')
         }
    });
});

  $('#shopify-section-blog-template .zoom-gallery').magnificPopup({
    delegate: 'a',
    type: 'image',
    closeOnContentClick: false,
    closeBtnInside: false,
    closeOnBgClick: false,
    mainClass: 'mfp-with-zoom mfp-img-mobile',
    image: {
      verticalFit: true
    },
    gallery: {
      arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
      tPrev: 'Previous (Left arrow key)',
      tNext: 'Next (Right arrow key)',
      enabled: true,
      navigateByImgClick: false
    },
    zoom: {
      enabled: true,
      duration: 300,
      opener: function(element) {
        return element.find('img');
      }
    }
  });

  // Tags dropdown.
  $('.header-column-dropdown').on('click', function(e) {
    const $dropdownWrapper = $(this).find('.dropdown-list-wrapper');
    if ($(this).hasClass('open')) {
      $dropdownWrapper.css('max-height', '0');
      $(this).removeClass('open');
    } else {
      $dropdownWrapper.css('max-height', '330px');
      $(this).addClass('open');
    }
  });

})

// image zoom function for gallery page
function zoom() {
  window.addEventListener('click', (e) => {
    if (e.target.classList.contains('gallery-img') || e.target.classList.contains('has-metafield-image') || e.target.parentElement.classList.contains('gallery-img-link')) {
      const image = document.querySelector('.mfp-img');
      const arrows = document.querySelectorAll('.mfp-arrow');

      if (image) {
        image.addEventListener('click', (e) => {
          e.target.classList.toggle('mfp-img--zoomed');
        });
      };

      if (arrows.length) {
        arrows.forEach((arrow) => {
          arrow.addEventListener('click', (e) => {
            const image = document.querySelector('.mfp-img');

            if (image) {
              image.addEventListener('click', (e) => {
                e.target.classList.toggle('mfp-img--zoomed');
              });
            };
          });
        });
      };
    };
  });
};
zoom();

// Set CSS for large portrait images
function largeImageLayout() {
  let imgLinks = document.querySelectorAll('.gallery-img-link');

  function styleLargeImgs(links) {
    let j = 0;
    let k = 11;
    links.forEach((link, index) => {
      if (index == j) {
        link.style.cssText = `
          grid-column: span 2;
          grid-row: span 2;
        `;
        j += 18;
      };
      if (index == k) {
        link.style.cssText = `
          grid-column: span 2;
          grid-row: span 2;
        `;
        k += 18;
      };
    });
  };
  styleLargeImgs(imgLinks);

  window.addEventListener('click', (e) => {
    if (e.target.textContent.toLowerCase() == 'load more') {
      setTimeout(() => {
        imgLinks = document.querySelectorAll('.gallery-img-link');
        styleLargeImgs(imgLinks);
      }, 2000);
    };
  });
};
largeImageLayout();
/* ========== End Brides Gallery Page JS ========== */